/* Gebrauchtmarkt (CompuHub, 2026-09-28) — nur auf den Seiten mit sections/cm-used-product.liquid geladen.
 *
 * 1. Pflicht-Kästchen: „In den Warenkorb“ bleibt deaktiviert, bis jedes Kästchen dieses Geräts angekreuzt ist
 *    (Zusatz Gebrauchtmarkt Abschnitt 7). Zusätzlich hält ein Abfangen des Absendens in der Capture-Phase jede
 *    Bestellung ohne Häkchen auf – auch per Enter-Taste –, bevor Dawns product-form.js sie in den Warenkorb legt.
 *    Hinweis: form.id liefert das Eingabefeld „id“, nicht die ID des Formulars – deshalb getAttribute('id').
 * 2. Galerie: Wischen, Vorschaubilder, Pfeile, Tastatur, Foto groß im <dialog>.
 * 3. Übersicht: Filter nach Gerät, Zustand und Art (auf der geladenen Seite) und Sortierung über ?sort_by=.
 */
(() => {
  if (window.cmUsed) return;
  window.cmUsed = true;

  // Texte in der Sprache der Seite: window.cmT.used aus snippets/cm-x-js-texts (Texte in snippets/cm-xt-js, Abschnitt used). Fehlt cmT oder
  // ein Schlüssel, gilt der deutsche Text hier; {name} wird ersetzt.
  const cmTexts = (window.cmT && window.cmT.used) || {};
  const tx = (key, de, vars) => {
    const own = cmTexts[key];
    const text = typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
    return vars ? text.replace(/\{(\w+)\}/g, (all, name) => (name in vars ? vars[name] : all)) : text;
  };

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ------------------------------------------------------------------------------------ Kästchen
  const boxesOf = (form) => (form ? Array.from(form.querySelectorAll('[data-cm-used-consent]')) : []);

  const syncForm = (form) => {
    const boxes = boxesOf(form);
    if (!boxes.length) return;
    const button = form.querySelector('[name="add"]');
    if (!button || button.dataset.cmUsedSold === 'true') return;
    const ready = boxes.every((box) => box.checked);
    button.disabled = !ready;
    button.dataset.cmUsedLocked = String(!ready);
    const hint = form.querySelector('[data-cm-used-lock]');
    if (hint) {
      hint.hidden = ready;
      if (ready) hint.classList.remove('is-alert');
    }
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.matches('[data-cm-used-consent]')) syncForm(target.form);
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const boxes = boxesOf(form);
      if (!boxes.length) return;
      const open = boxes.find((box) => !box.checked);
      if (!open) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      syncForm(form);
      const hint = form.querySelector('[data-cm-used-lock]');
      if (hint) {
        hint.hidden = false;
        hint.classList.add('is-alert');
      }
      open.focus();
      open.closest('.cm-used-consent')?.scrollIntoView({ block: 'center', behavior: reduceMotion() ? 'auto' : 'smooth' });
    },
    true
  );

  // ------------------------------------------------------------------------------------ Details zu den Kästchen
  // Kurzer Text am Kästchen, voller Wortlaut im Fenster (snippets/cm-used-buy). Schließen: Knopf, Esc, Klick daneben.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const more = target.closest('[data-cm-used-more]');
    if (more) {
      const dialog = document.getElementById(more.getAttribute('aria-controls') || '');
      if (dialog instanceof HTMLDialogElement && !dialog.open) {
        dialog.showModal();
        dialog.querySelector('[data-cm-used-close]')?.focus({ preventScroll: true });
        dialog.scrollTop = 0;
      }
      return;
    }
    if (target.closest('[data-cm-used-close]')) {
      target.closest('dialog')?.close();
      return;
    }
    if (target instanceof HTMLDialogElement && target.matches('[data-cm-used-dialog]')) target.close();
  });

  // ------------------------------------------------------------------------------------ Galerie
  const initGallery = (root) => {
    if (root.dataset.cmUsedReady === 'true') return;
    root.dataset.cmUsedReady = 'true';
    const track = root.querySelector('[data-cm-used-track]');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('[data-cm-used-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-cm-used-thumb]'));
    const prev = root.querySelector('[data-cm-used-prev]');
    const next = root.querySelector('[data-cm-used-next]');
    const current = root.querySelector('[data-cm-used-current]');
    const strip = root.querySelector('.cm-used-gallery__thumbs');
    let index = 0;
    let frame = 0;

    const mark = (i) => {
      thumbs.forEach((thumb, j) => thumb.setAttribute('aria-current', String(i === j)));
      if (current) current.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      // Only the strip scrolls sideways — scrollIntoView would also move the page on a phone.
      const thumb = thumbs[i];
      if (strip && thumb && strip.scrollWidth > strip.clientWidth) {
        const box = thumb.getBoundingClientRect();
        const edge = strip.getBoundingClientRect();
        if (box.left < edge.left) strip.scrollLeft -= edge.left - box.left + 8;
        else if (box.right > edge.right) strip.scrollLeft += box.right - edge.right + 8;
      }
    };
    const go = (i) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: index * track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
      mark(index);
    };

    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== index) {
            index = i;
            mark(i);
          }
        });
      },
      { passive: true }
    );
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(index + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(index - 1);
      }
    });
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => go(Number(thumb.dataset.cmUsedThumb))));
    if (slides.length > 1 && window.matchMedia('(hover: hover)').matches) {
      if (prev) {
        prev.hidden = false;
        prev.addEventListener('click', () => go(index - 1));
      }
      if (next) {
        next.hidden = false;
        next.addEventListener('click', () => go(index + 1));
      }
    }
    mark(0);

    const dialog = root.querySelector('[data-cm-used-dialog]');
    const big = dialog?.querySelector('[data-cm-used-zoom-img]');
    root.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-cm-used-zoom]') : null;
      if (!link || !dialog || !big || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      big.src = link.getAttribute('href');
      big.alt = link.querySelector('img')?.getAttribute('alt') || '';
      dialog.showModal();
    });
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  };

  // ------------------------------------------------------------------------------------ Übersicht
  const GRADE_ORDER = ['Wie neu', 'Sehr gut', 'Gut', 'Akzeptabel'];
  const DIMENSIONS = [
    ['family', tx('family', 'Gerät'), tx('family_all', 'Alle Geräte')],
    ['grade', tx('grade', 'Zustand'), tx('grade_all', 'Jeder Zustand')],
    ['kind', tx('kind', 'Art'), tx('kind_all', 'Alle Arten')],
  ];
  // Beschriftung der Filterknöpfe für die bekannten Datenwerte (snippets/cm-used-card.liquid); der Wert selbst — und damit
  // Filter und Sortierung — bleibt der deutsche aus den data-Attributen. Unbekannte Werte (Gerätefamilien) stehen wie geliefert.
  const VALUE_LABELS = {
    grade: { 'Wie neu': tx('grade_like_new', 'Wie neu'), 'Sehr gut': tx('grade_very_good', 'Sehr gut'), 'Gut': tx('grade_good', 'Gut'), 'Akzeptabel': tx('grade_acceptable', 'Akzeptabel') },
    kind: { 'Gebraucht': tx('kind_used', 'Gebraucht'), 'Vorführgerät': tx('kind_demo', 'Vorführgerät'), 'Privatverkauf': tx('kind_private', 'Privatverkauf') },
    family: { 'Sonstiges': tx('family_other', 'Sonstiges') },
  };
  const valueLabel = (key, value) => (Object.prototype.hasOwnProperty.call(VALUE_LABELS[key] || {}, value) ? VALUE_LABELS[key][value] : value);

  const initCollection = (root) => {
    if (root.dataset.cmUsedReady === 'true') return;
    root.dataset.cmUsedReady = 'true';

    const sort = root.querySelector('[data-cm-used-sort]');
    sort?.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    const cards = Array.from(root.querySelectorAll('[data-cm-used-grid] [data-cm-used-card]'));
    const bar = root.querySelector('[data-cm-used-filters]');
    const count = root.querySelector('[data-cm-used-count]');
    const nomatch = root.querySelector('[data-cm-used-nomatch]');
    if (!bar || cards.length < 2) return;
    const initialCount = count?.textContent ?? '';
    const state = { family: '', grade: '', kind: '' };
    const groups = [];

    const apply = () => {
      let shown = 0;
      for (const card of cards) {
        const match = DIMENSIONS.every(([key]) => !state[key] || card.dataset[key] === state[key]);
        card.hidden = !match;
        if (match) shown += 1;
      }
      const filtered = DIMENSIONS.some(([key]) => state[key]);
      if (count) count.textContent = filtered ? (shown === 1 ? tx('match_one', '{count} Gerät passend', { count: shown }) : tx('match_other', '{count} Geräte passend', { count: shown })) : initialCount;
      if (nomatch) nomatch.hidden = shown > 0;
    };

    for (const [key, label, all] of DIMENSIONS) {
      const values = Array.from(new Set(cards.map((card) => card.dataset[key]).filter(Boolean)));
      if (key === 'grade') values.sort((a, b) => GRADE_ORDER.indexOf(a) - GRADE_ORDER.indexOf(b));
      else values.sort((a, b) => a.localeCompare(b, 'de'));
      if (values.length < 2) continue;
      const group = document.createElement('div');
      group.className = 'cm-used-filter';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', label);
      for (const value of ['', ...values]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = value ? valueLabel(key, value) : all;
        // Same coloured dot as on the cards (snippets/cm-used-grade, colours in cm-used-grade.css); only the four known grades.
        const gradeKey = key === 'grade' && GRADE_ORDER.includes(value) ? value.toLowerCase().replace(/\s+/g, '-') : '';
        if (gradeKey) {
          const dot = document.createElement('span');
          dot.className = `cm-grade--${gradeKey} cm-grade__dot`;
          dot.setAttribute('aria-hidden', 'true');
          button.prepend(dot);
        }
        button.setAttribute('aria-pressed', String(value === ''));
        button.addEventListener('click', () => {
          state[key] = value;
          group.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
          apply();
        });
        group.append(button);
      }
      groups.push([key, group]);
      bar.append(group);
    }
    if (!groups.length) return;
    bar.hidden = false;

    root.querySelector('[data-cm-used-reset]')?.addEventListener('click', () => {
      for (const [key, group] of groups) {
        state[key] = '';
        group.querySelectorAll('button').forEach((b, i) => b.setAttribute('aria-pressed', String(i === 0)));
      }
      apply();
    });
  };

  // ------------------------------------------------------------------------------------ Start
  const init = (scope = document) => {
    scope.querySelectorAll('[data-cm-used-form] form').forEach(syncForm);
    scope.querySelectorAll('[data-cm-used-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-cm-used-collection]').forEach(initCollection);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  // Zurück-Navigation aus dem Cache: Häkchen können gesetzt geblieben sein.
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-cm-used-form] form').forEach(syncForm));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
